import { useEffect } from "react"
import useMarttiData from "hooks/useMarttiData"
import useStore from "store"
import { selectAccessCode } from "store/selectors/accessCode"

export const useCustomFields = (unitId, accessCodeObject, answeredCall) => {
  const { getMartti, martti, resetMartti } = useMarttiData(unitId)
  const [accessCode, setAccessCode] = useStore(selectAccessCode)

  useEffect(() => {
    const martti = getMartti()
    const accessCode = accessCodeObject ?? martti?.accessCode
    setAccessCode({ ...accessCode })
  }, [accessCodeObject, getMartti, setAccessCode])

  useEffect(() => {
    if (!answeredCall) {
      setAccessCode({})
      resetMartti()
    }
  }, [answeredCall, setAccessCode, resetMartti])

  return {
    accessCode,
    departmentId: martti?.departmentId || accessCode?.department || "",
  }
}
